// Яндекс.Метрика для приложения (тот же счётчик, что на лендинге: 109704785).
//
// SPA-специфика: инициализируем с defer:true (Метрика НЕ шлёт первый просмотр сама),
// а каждый просмотр — включая первый — отправляем вручную через ymHit при смене роута
// (см. MetrikaTracker). Так нет двойного учёта и сохраняется UTM из URL (?utm_source=vk…),
// по которому Метрика атрибутирует канал (VK/TG/Дзен/лендинг).
//
// В dev (vite dev, import.meta.env.PROD=false) счётчик не подключается — не сорим в прод.

export const YM_ID = 109704785;

type Ym = ((...args: unknown[]) => void) & { a?: unknown[]; l?: number };

declare global {
  interface Window {
    ym?: Ym;
  }
}

let started = false;

/** Однократная инициализация счётчика (только в production-сборке). */
export function initMetrika(): void {
  if (!import.meta.env.PROD || started || typeof window === 'undefined') return;
  started = true;
  const w = window;
  w.ym =
    w.ym ||
    (function ymStub() {
      (w.ym!.a = w.ym!.a || []).push(arguments);
    } as unknown as Ym);
  w.ym!.l = Number(new Date());
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://mc.yandex.ru/metrika/tag.js?id=${YM_ID}`;
  document.head.appendChild(s);
  w.ym!(YM_ID, 'init', {
    defer: true, // первый просмотр шлём вручную (ymHit), чтобы не задвоить SPA
    // Вебвизор выключен (решение владельца 2026-10-15): записи сессий — только Amplitude.
    clickmap: true,
    accurateTrackBounce: true,
    trackLinks: true,
  });
}

/** Просмотр страницы при SPA-переходе. url должен включать query (UTM!). */
export function ymHit(url: string, prev?: string): void {
  window.ym?.(YM_ID, 'hit', url, prev ? { referer: prev } : undefined);
}

/** Достижение цели (регистрация, оплата и т.п.). */
export function ymGoal(goal: string, params?: Record<string, unknown>): void {
  window.ym?.(YM_ID, 'reachGoal', goal, params);
}
